import React from 'react';
import PropTypes from 'prop-types';
import { getOr, unescape } from 'lodash/fp';

import { Table } from 'rsuite';

const { Cell } = Table;

const UnescapeCell = ({ dataKey, rowData, ...props }) => (
  <Cell {...props}>{unescape(getOr('', dataKey, rowData))}</Cell>
);

UnescapeCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({})
};

UnescapeCell.defaultProps = {
  rowData: null
};

export default UnescapeCell;
